import { useQuery } from '@apollo/client'
import { Hidden } from '@material-ui/core'
import { matchSorter } from 'match-sorter'
import { useEffect, useMemo, useState } from 'react'

import { TENANTS_QUERY } from '../../graphql/tenant'
import { Tenant } from '../../types/tenants'
import TenantListDesktop from './TenantListDesktop'
import TenantListMobile from './TenantListMobile'
import TenantsHeader from './TenantsHeader'

const TenantList = () => {
  const [searchInputValue, setsearchInputValue] = useState<string>('')
  const [page, setPage] = useState(1)
  const [count, setcount] = useState(0)
  const [filteredTenants, setfilteredTenants] = useState<Tenant[]>([])
  const {
    data: tenants,
    loading,
    refetch
  } = useQuery<{ tenants: Tenant[] }>(TENANTS_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      showLog: true
    }
  })
  const [perPage] = useState(5)

  const numberOfPages = useMemo(() => Math.ceil(count / perPage), [count])

  useEffect(() => {
    setPage(1)
    const fullTenantsList = tenants?.tenants ? tenants?.tenants : []
    const newFilteredTenants = matchSorter(fullTenantsList, searchInputValue, {
      keys: ['basicDetails.name', 'basicDetails.displayTenantCode'],
      sorter: (rankedItems) =>
        rankedItems.sort((a, b) => {
          return a.item.basicDetails.name > b.item.basicDetails.name ? 1 : -1
        })
    })
    setfilteredTenants(newFilteredTenants)
    setcount(newFilteredTenants.length)
  }, [searchInputValue, loading])

  return (
    <>
      <TenantsHeader
        searchInputValue={searchInputValue}
        setsearchInputValue={setsearchInputValue}
      />
      <Hidden smDown>
        <TenantListDesktop
          refetch={refetch}
          filteredTenants={filteredTenants}
          page={page}
          perPage={perPage}
          loading={loading}
          numberOfPages={numberOfPages}
          setPage={setPage}
        />
      </Hidden>
      <Hidden mdUp>
        <TenantListMobile
          refetch={refetch}
          filteredTenants={filteredTenants}
          page={page}
          perPage={perPage}
          loading={loading}
          numberOfPages={numberOfPages}
          setPage={setPage}
        />
      </Hidden>
    </>
  )
}
export default TenantList
